import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

class Analytics extends Component {
	constructor(props) {
		super(props)

		// Initial page load - only fired once
		GoogleAnalytics.initialize('UA-53476446-9');
		GoogleAnalytics.plugin.require('ecommerce');
		this.pageView(props.location.pathname, props.location.search)
	}

	componentWillReceiveProps(nextProps) {
		// When props change, check if the URL has changed or not
		if (this.props.location.pathname !== nextProps.location.pathname || this.props.location.search !== nextProps.location.search) {
			this.pageView(nextProps.location.pathname, nextProps.location.search)
		}
	}

	pageView(pathname, search='') {
		// console.log('pageView',pathname, search);
		const page = pathname + search
		GoogleAnalytics.set({page});
		GoogleAnalytics.pageview(page);
	}

	render() {
		return null
	}
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/components/helpers/analytics.js